import React, { Component } from "react";

import Tooltip from "../tooltip";

import BlockImage from "./blockImage";

import "./materials.css";

class Materials extends Component {
  state = { onlyMaxPerSplit: false };

  onOnlyMaxPerSplitChange = () => {
    this.setState((currentState) => ({
      // nb this method of passing currentState instead of using this.state... is prefered; TODO neaten up controller uses
      onlyMaxPerSplit: !currentState.onlyMaxPerSplit,
    }));
  };

  getMaterialsCount_nonZeroMaterialsItems() {
    const { coloursJSON, currentMaterialsData } = this.props;
    const { onlyMaxPerSplit } = this.state;
    const materialsCount = {};
    for (const colourSetId of Object.keys(coloursJSON)) {
      materialsCount[colourSetId] = 0;
    }
    for (const row of currentMaterialsData.maps) {
      for (const map of row) {
        for (const [colourSetId, materialCount] of Object.entries(map.materials)) {
          if (onlyMaxPerSplit) {
            materialsCount[colourSetId] = Math.max(materialsCount[colourSetId], materialCount);
          } else {
            materialsCount[colourSetId] += materialCount;
          }
        }
      }
    }
    return Object.entries(materialsCount)
      .filter(([_, value]) => value !== 0)
      .sort((first, second) => {
        return second[1] - first[1];
      });
  }

  // support / layer 0 blocks of one map as they appear in the downloads: the joined schematic has ONE noobline row on top of the whole map,
  // so maps below the first map row do not add a noobline (nor plate cells under it). "Max per split" keeps every map complete.
  getMapSupportCounts(map, rowIndex) {
    const { onlyMaxPerSplit } = this.state;
    let support = map.supportBlockCount;
    let plate = map.layer0PlateCount || 0;
    if (!onlyMaxPerSplit && rowIndex > 0) {
      const noobPlate = map.noobLinePlateCount || 0;
      support -= (map.noobLineCount || 0) + noobPlate;
      plate -= noobPlate;
    }
    return { support, plate };
  }

  getMaterialsCount_supportBlock() {
    const { currentMaterialsData, excludeLayer0 } = this.props;
    const { onlyMaxPerSplit } = this.state;
    let supportBlockCount = 0;
    currentMaterialsData.maps.forEach((row, rowIndex) => {
      row.forEach((map) => {
        const counts = this.getMapSupportCounts(map, rowIndex);
        const count = counts.support - (excludeLayer0 ? counts.plate : 0);
        supportBlockCount = onlyMaxPerSplit ? Math.max(supportBlockCount, count) : supportBlockCount + count;
      });
    });
    return supportBlockCount;
  }

  // amount on the first line; below it, small: stacks (64) and shulker boxes (27 stacks) with a shulker icon
  formatMaterialCount = (count) => {
    const { getLocaleString } = this.props;
    const stacks = Math.floor(count / 64);
    const remainder = count % 64;
    const shulkers = Math.floor(stacks / 27);
    const stacksLeft = stacks % 27;
    const stackWord = (n) => getLocaleString(n === 1 ? "MATERIALS/STACK" : "MATERIALS/STACKS");
    const shulkerWord = getLocaleString("MATERIALS/SHULKER");
    return (
      <React.Fragment>
        <div className="materialAmount">{count.toString()}</div>
        {stacks > 0 ? (
          <div className="materialDetails">
            <span>{`${stacks} ${stackWord(stacks)}${remainder > 0 ? ` + ${remainder}` : ""}`}</span>
            {shulkers > 0 ? (
              <span className="materialShulkers">
                <svg className="shulkerIcon" viewBox="0 0 16 16" width="13" height="13" aria-hidden="true">
                  <rect x="1" y="6" width="14" height="9" fill="#8a5a8a" />
                  <rect x="1" y="2" width="14" height="5" fill="#b27fb2" />
                  <rect x="1" y="6" width="14" height="1.5" fill="#5e3a5e" />
                  <rect x="6.5" y="6.5" width="3" height="3" fill="#e3cf8a" />
                </svg>
                {` ${shulkers} ${shulkerWord}${stacksLeft > 0 || remainder > 0 ? ` + ${stacksLeft} ${stackWord(stacksLeft)}${remainder > 0 ? ` + ${remainder}` : ""}` : ""}`}
              </span>
            ) : null}
          </div>
        ) : null}
      </React.Fragment>
    );
  };

  // how many layer 0 plate blocks are currently left out of the list
  getHiddenLayer0Count() {
    const { currentMaterialsData, excludeLayer0 } = this.props;
    const { onlyMaxPerSplit } = this.state;
    if (!excludeLayer0) return 0;
    let hidden = 0;
    currentMaterialsData.maps.forEach((row, rowIndex) => {
      row.forEach((map) => {
        const count = this.getMapSupportCounts(map, rowIndex).plate;
        hidden = onlyMaxPerSplit ? Math.max(hidden, count) : hidden + count;
      });
    });
    return hidden;
  }

  colourSetIdAndBlockIdFromNBTName(blockName) {
    const { coloursJSON, optionValue_version } = this.props;
    for (const [colourSetId, colourSet] of Object.entries(coloursJSON)) {
      for (const [blockId, block] of Object.entries(colourSet.blocks)) {
        if (!(optionValue_version.MCVersion in block.validVersions)) {
          continue;
        }
        let blockNBTData = block.validVersions[optionValue_version.MCVersion];
        if (typeof blockNBTData === "string") {
          // this is of the form eg "&1.12.2"
          blockNBTData = block.validVersions[blockNBTData.slice(1)];
        }
        if (
          Object.keys(blockNBTData.NBTArgs).length === 0 && // no exotic blocks for noobline
          blockName.toLowerCase() === blockNBTData.NBTName.toLowerCase()
        ) {
          return { colourSetId, blockId };
        }
      }
    }
    return null; // if block not found
  }

  render() {
    const { getLocaleString, coloursJSON, optionValue_supportBlock, currentMaterialsData } = this.props;
    const { onlyMaxPerSplit } = this.state;
    const nonZeroMaterialsItems = this.getMaterialsCount_nonZeroMaterialsItems();
    const supportBlockCount = this.getMaterialsCount_supportBlock();
    const hiddenLayer0Count = this.getHiddenLayer0Count();
    const supportBlockIds = this.colourSetIdAndBlockIdFromNBTName(optionValue_supportBlock);
    return (
      <div className="section materialsDiv">
        <h2>{getLocaleString("MATERIALS/TITLE")}</h2>
        <Tooltip tooltipText={getLocaleString("MATERIALS/SHOW-PER-SPLIT-TT")}>
          <b>
            {getLocaleString("MATERIALS/SHOW-PER-SPLIT")}
            {":"}
          </b>
        </Tooltip>{" "}
        <input type="checkbox" checked={onlyMaxPerSplit} onChange={this.onOnlyMaxPerSplitChange} />
        <br />
        {hiddenLayer0Count > 0 ? (
          <em className="settingNote">
            {getLocaleString("MATERIALS/LAYER0-HIDDEN").replace("{count}", hiddenLayer0Count.toString()).replace("{block}", optionValue_supportBlock)}
          </em>
        ) : null}
        <table id="materialtable">
          <tbody>
            <tr>
              <th>{getLocaleString("MATERIALS/BLOCK")}</th>
              <th>{getLocaleString("MATERIALS/AMOUNT")}</th>
            </tr>
            {supportBlockCount !== 0 && (
              <tr>
                <th>
                  <Tooltip tooltipText={getLocaleString("MATERIALS/PLACEHOLDER-BLOCK-TT")}>
                    <BlockImage
                      getLocaleString={getLocaleString}
                      coloursJSON={coloursJSON}
                      colourSetId={supportBlockIds === null ? "64" : supportBlockIds.colourSetId}
                      blockId={supportBlockIds === null ? "2" : supportBlockIds.blockId}
                    />
                  </Tooltip>
                </th>
                <th>{this.formatMaterialCount(supportBlockCount)}</th>
              </tr>
            )}
            {nonZeroMaterialsItems.map(([colourSetId, materialCount]) => {
              const blockId = currentMaterialsData.currentSelectedBlocks[colourSetId];
              return (
                <tr key={colourSetId}>
                  <th>
                    <Tooltip tooltipText={coloursJSON[colourSetId].blocks[blockId].displayName}>
                      <BlockImage coloursJSON={coloursJSON} colourSetId={colourSetId} blockId={blockId} />
                    </Tooltip>
                  </th>
                  <th>{this.formatMaterialCount(materialCount)}</th>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

export default Materials;
